module.exports = __webpack_public_path__ + "img/indeed.34064f48.jpeg";